<template>
    <div v-if="showPopup" class="column_center_center w-screen h-screen fixed inset-0"
        style="background-color: rgba(0, 0, 0, 0.7);">
        <div class="column_center_around popup">
            <div class="title text-[28px] text-primary-color">{{ title_1 }}</div>
            <div class="my-6 w-full px-[30px] text-[#666666]">
                {{ content_1 }}
            </div>
            <div class="row_center_between w-full">
                <div class="row_center_center cancel_button" @click="cancel">{{ cancelText_1 }}</div>
                <div class="row_center_center confirm_button" @click="confirm">{{ confirmText_1 }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '確定'
        }
    },
    data() {
        return {
            showPopup: false,
            title_1: this.title,
            content_1: this.content,
            cancelText_1: this.cancelText,
            confirmText_1: this.confirmText,
            confirmEvent: null,
            cancelEvent: null
        }
    },
    methods: {
        confirm() {
            this.showPopup = false
            this.$emit('confirm', this.confirmEvent)
        },
        cancel() {
            this.showPopup = false
            if (this.cancelEvent === null) return
            this.$emit('cancel', this.cancelEvent)
        },
        show({ title, content, cancelText, confirmText, confirmEvent, cancelEvent }) {
            if (title) this.title_1 = title
            if (content) this.content_1 = content
            if (cancelText) this.cancelText_1 = cancelText
            if (confirmText) this.confirmText_1 = confirmText
            if (confirmEvent) this.confirmEvent = confirmEvent
            if (cancelEvent) this.cancelEvent = cancelEvent
            this.showPopup = true
        }
    }
}
</script>
<style lang="scss" scope>
.popup {
    width: 80%;
    padding: 30px 0 0;
    background-color: #fff;
    border-radius: 8px;
    font-size: 18px;
    text-align: center;

    .cancel_button {
        width: 50%;
        height: 56px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        font-family: PingFang SC;
        color: #000;
        border-radius: 0 0 0 8px;
        background-color: #EEEEEE;
    }

    .confirm_button {
        width: 50%;
        height: 56px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        font-family: PingFang SC;
        color: #000;
        border-radius: 0 0 8px 0;
        background-color: #FBCB02;
    }
}
</style>